import functions from '../../services/functions'
import user from '../../api/user'
import {
  GET_MYPROFILE_REQUEST,
  GET_MYPROFILE_SUCCESS,
  GET_MYPROFILE_FAILURE
} from '../mutation-types'

// initial state
const state = {
  myProfile: {
    userId: null,
    mqttAccessToken: null,
    email: null,
    firstName: null,
    lastName: null,
    created: null,
    isEmailVerified: null,
    profilePictureUrl: null
  },
  status: {
    getMyProfile: null
  },
  getMyProfileStatus: null
}

// getters
const getters = {
  myName: function (state) {
    return state.myProfile.firstName ? state.myProfile.firstName + ' ' + state.myProfile.lastName : null
  },
  isValidAccount: function (state) {
    return state.myProfile.isEmailVerified
  },
  myMqttAccessToken: function (state) {
    return state.myProfile.mqttAccessToken
  }
}

// actions
const actions = {
  getMyProfile: function ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      commit(GET_MYPROFILE_REQUEST)
      user.getMyProfile().then(
        res => {
          if (res.body[0] instanceof Object) {
            if (functions.hasAllKeys(res.body[0], [
              'user_id',
              'access_token',
              'email',
              'created',
              'is_verify'
            ])) {
              commit(GET_MYPROFILE_SUCCESS, {
                userId: res.body[0].user_id,
                mqttAccessToken: res.body[0].access_token,
                email: res.body[0].email,
                firstName: res.body[0].firstname,
                lastName: res.body[0].lastname,
                created: res.body[0].created,
                isEmailVerified: res.body[0].is_verify,
                profilePictureUrl: res.body[0].provider_picture
              })
              resolve()
            } else {
              commit(GET_MYPROFILE_FAILURE)
              reject({
                status: res.status,
                statusText: res.statusText,
                body: res.body,
                successButText: 'incorrect api response'
              })
            }
          } else {
            commit(GET_MYPROFILE_FAILURE)
            reject({
              status: res.status,
              statusText: res.statusText,
              body: res.body,
              successButText: 'incorrect api response'
            })
          }
          dispatch('checkOnlineStatusByApiResponse', res)
        },
        err => {
          console.log(err)
          dispatch('checkOnlineStatusByApiResponse', err)
          commit(GET_MYPROFILE_FAILURE)
          reject({
            status: err.status,
            statusText: err.statusText,
            body: err.body
          })
        }
      )
    })
  }
}

// mutations
const mutations = {
  [GET_MYPROFILE_REQUEST]: function (state) {
    state.status = {...state.status, getMyProfile: 'requested'}
  },
  [GET_MYPROFILE_SUCCESS]: function (state, profile) {
    state.status = {...state.status, getMyProfile: 'successful'}
    state.myProfile = profile
  },
  [GET_MYPROFILE_FAILURE]: function (state) {
    state.status = {...state.status, getMyProfile: 'failed'}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/myProfile.js